import { render } from "./CreateProperty.vue?vue&type=template&id=2c291d82&scoped=true"
import script from "./CreateProperty.vue?vue&type=script&lang=js"
export * from "./CreateProperty.vue?vue&type=script&lang=js"

import "./CreateProperty.vue?vue&type=style&index=0&id=2c291d82&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c291d82"]])

export default __exports__